module.exports = __webpack_public_path__ + "img/brussels-histogram.3f31a274.svg";